import { render, staticRenderFns } from "./DeodorizerDviceMonitoring.vue?vue&type=template&id=2c50e864&scoped=true"
import script from "./DeodorizerDviceMonitoring.vue?vue&type=script&lang=js"
export * from "./DeodorizerDviceMonitoring.vue?vue&type=script&lang=js"
import style0 from "./DeodorizerDviceMonitoring.vue?vue&type=style&index=0&id=2c50e864&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c50e864",
  null
  
)

export default component.exports